import { useCallback, useState, type RefObject } from "react";

export type UseDragAndScrollParams = {
  elementToScroll: RefObject<HTMLDivElement | null>;
  direction: "horizontal" | "vertical";
};

export default ({ elementToScroll, direction }: UseDragAndScrollParams) => {
  const [mouseIn, setMouseIn] = useState(false);

  const onMouseLeave = useCallback(() => {
    if (mouseIn) setMouseIn(false);
  }, [mouseIn]);

  const onMouseUp = useCallback(() => {
    if (mouseIn) setMouseIn(false);
  }, [mouseIn]);

  const onMouseDown = useCallback(() => {
    if (!mouseIn) setMouseIn(true);
  }, [mouseIn]);

  const onMouseMoveCapture = useCallback(
    (e: MouseEvent) => {
      if (mouseIn && elementToScroll && elementToScroll.current) {
        if (direction === "horizontal")
          elementToScroll.current.scrollLeft += e.movementX * -1;

        if (direction === "vertical")
          elementToScroll.current.scrollTop += e.movementY * -1;
      }
    },
    [mouseIn, elementToScroll, direction],
  );

  return { onMouseLeave, onMouseDown, onMouseUp, onMouseMoveCapture };
};
